/**
 * Chip del estado de una campaña.
 *
 * Mapea los estados REALES del backend. Ojo: `types.ts` (mundo mock) declara
 * estados en español ('borrador' | 'enviando' | 'medida') que no existen en la API.
 */

import type { EstadoCampana } from "../types.real";

const MAP: Record<EstadoCampana, { label: string; cls: string }> = {
  draft: { label: "Borrador", cls: "bg-amber-50 text-amber-600" },
  analyzed: { label: "Analizada", cls: "bg-slate-100 text-slate-600" },
  context: { label: "Oferta elegida", cls: "bg-slate-100 text-slate-600" },
  messaged: { label: "Mensajes listos", cls: "bg-slate-100 text-slate-600" },
  // El Record es exhaustivo A PROPÓSITO (no Partial): agregar un estado al backend y olvidarse de
  // acá rompe el build en vez de caer en el fallback `|| MAP.draft` — que mostraría "Borrador"
  // sobre una campaña que le va a escribir a 183 personas mañana a las 10.
  programada: { label: "Programada", cls: "bg-indigo-50 text-indigo-600" },
  enviando: { label: "Enviando", cls: "bg-sky-50 text-sky-600" },
  sent: { label: "Enviada", cls: "bg-emerald-50 text-emerald-700" },
  measured: { label: "Medida", cls: "bg-violet-50 text-violet-700" },
};

export const estadoInfo = (estado?: string) => MAP[(estado || "draft") as EstadoCampana] || MAP.draft;

export default function ChipEstado({ estado, className = "" }: { estado?: string; className?: string }) {
  const { label, cls } = estadoInfo(estado);
  return <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full ${cls} ${className}`}>{label}</span>;
}
